import { useHomepagePageData, useHomepagePageUserData } from '#src/app/pages/homepage/pageContext';
import type { HomepagePageData } from '#src/app/pages/homepage/pageContext';

type HeroFeatureFlagsConfig = HomepagePageData['featureConfigs']['homepageHeroFeatureFlags'];
type HeroFeatureFlags = NonNullable<HeroFeatureFlagsConfig[keyof HeroFeatureFlagsConfig]>;

type Result = ModelHookResult<{ flags: HeroFeatureFlags }>;

/**
 * Flags from `homepage_hero_feature_flags` for the hero variant being rendered. The FCM lives in
 * page data rather than user data because user data rejects nested properties other than
 * `experiments`.
 *
 * `homepage_hero_experiment` resolves to `control` when GrowthBook doesn't bucket the user, so the
 * nested starfish fallback heroes read the `control` entry.
 */
export function useHeroFeatureFlags(): Result {
	const {
		data: { featureConfigs },
	} = useHomepagePageData();
	const {
		data: { experiments },
	} = useHomepagePageUserData();

	return {
		data: { flags: featureConfigs.homepageHeroFeatureFlags[experiments.homepageHeroExperiment.variation] ?? {} },
	};
}
